import { render, staticRenderFns } from "./sitesetting.vue?vue&type=template&id=7937f4f9&scoped=true&"
import script from "./sitesetting.vue?vue&type=script&lang=js&"
export * from "./sitesetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7937f4f9",
  null
  
)

export default component.exports